import { GiftOpenOutlineIcon } from './GiftOpenOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 64BCFFC7-8E6B-4644-B14D-5B1F9EF16899
 * name gift-open-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gift-open-outline.svg
 * tags
 * - Holiday 
 */
export const PresentOpenOutlineIcon = GiftOpenOutlineIcon;
export default PresentOpenOutlineIcon